import type { FC } from 'react'

import type { TIconProps } from 'types'

const HearthIcon: FC<TIconProps> = ({ className }) => (
  <svg className={className} width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14.1166 21.6417L13.9999 21.7583L13.8716 21.6417C8.32992 16.6133 4.66659 13.2883 4.66659 9.91667C4.66659 7.58333 6.41659 5.83333 8.74992 5.83333C10.5466 5.83333 12.2966 7 12.9149 8.58667H15.0849C15.7033 7 17.4533 5.83333 19.2499 5.83333C21.5833 5.83333 23.3333 7.58333 23.3333 9.91667C23.3333 13.2883 19.6699 16.6133 14.1166 21.6417ZM19.2499 3.5C17.2199 3.5 15.2716 4.445 13.9999 5.92667C12.7283 4.445 10.7799 3.5 8.74992 3.5C5.15659 3.5 2.33325 6.31167 2.33325 9.91667C2.33325 14.315 6.29992 17.92 12.3083 23.3683L13.9999 24.9083L15.6916 23.3683C21.6999 17.92 25.6666 14.315 25.6666 9.91667C25.6666 6.31167 22.8433 3.5 19.2499 3.5Z'
      fill='#19171B'
    />
  </svg>
)

export default HearthIcon
